import { useMemo } from "react";

import { effectiveHealthBreakdown, type HealthScoreBreakdown } from "@/pages/dashboard/fiscalHealthScore";
import type { FiscalAgendaObligation } from "@/services/fiscalService";

/**
 * Returns a health breakdown whose score is derived from the same obligation
 * lists shown in the fiscal health modal, so the displayed score always matches
 * the modal (no 100 when there are overdue/due-today items).
 */
export function useEffectiveHealthBreakdown(
  healthBreakdown: HealthScoreBreakdown,
  overdueObligations: FiscalAgendaObligation[],
  dueTodayObligations: FiscalAgendaObligation[],
  dueIn1Obligations: FiscalAgendaObligation[],
  dueIn3Obligations: FiscalAgendaObligation[]
): HealthScoreBreakdown {
  return useMemo(
    () =>
      effectiveHealthBreakdown(
        healthBreakdown,
        overdueObligations.length,
        dueTodayObligations.length,
        dueIn1Obligations.length,
        dueIn3Obligations.length
      ),
    [
      healthBreakdown,
      overdueObligations.length,
      dueTodayObligations.length,
      dueIn1Obligations.length,
      dueIn3Obligations.length,
    ]
  );
}
